<template>
  <v-dialog :value="true" persistent max-width="650px" scrollable hide-overlay>
    <v-card class="login">
      <v-card-title class="gradient elevation-3">
        <v-toolbar-title style="color: white">
          <v-icon color="white">person</v-icon>
          Bem Vindo
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn small color="indigo" dark round outline @click="toRegister()">
          Registrar
        </v-btn>
      </v-card-title>
      <v-card-text>
        <v-form>
          <v-alert
            type="error"
            icon="error"
            dismissible v-model="alert.visible"
            transition="scale-transition"
          >
            {{this.alert.message}}
          </v-alert>
          <v-layout row justify-center align-center wrap>
            <v-flex xs12>
              <v-text-field prepend-icon="person" name="login" :label="translate(`table.users.field.email`)"
                            type="text" required
                            :error-messages="errors.collect('login')"
                            data-vv-validate-on="blur"
                            data-vv-delay="1000"
                            v-validate="'required'"
                            data-vv-as="E-mail"
                            v-model="user.email" @keyup.native.enter="login()" />
            </v-flex>
            <v-flex xs12>
              <v-text-field prepend-icon="lock" name="password" :label="translate(`table.users.field.password`)"
                            :type="showPassword ? 'text' : 'password'"
                            :append-icon="showPassword ? 'visibility' : 'visibility_off'"
                            @click:append="showPassword = !showPassword"
                            :error-messages="errors.collect('password')"
                            data-vv-validate-on="blur"
                            data-vv-delay="1000" @keyup.native.enter="login()"
                            v-validate="'required'"
                            :data-vv-as="translate(`table.users.field.password`)"
                            v-model="user.password"/>
            </v-flex>
            <v-flex xs12 class="py-0">
              <v-checkbox class="mt-1" hide-details label="Lembrar minha senha" key="3" @keyup.native.ctrl.enter="login()" v-model="rememberMe"/>
            </v-flex>
          </v-layout>
        </v-form>
      </v-card-text>
      <v-card-actions class="mb-3">
        <v-layout row justify-center align-center wrap>
          <v-flex xs12 class="text-xs-center py-0">
            <v-btn @click="login()" dark class="gradient" :loading="loading">
              Entrar
            </v-btn>
            <v-btn flat href="#/forgot">Esqueci minha senha</v-btn>
          </v-flex>
          <v-flex xs12 class="text-xs-center pt-0">
            <v-btn class="mt-3" flat color="blue" @click="toRegister()">Criar uma conta</v-btn>
          </v-flex>
        </v-layout >

        <!-- <v-flex class="text-xs-center">
          <v-btn href="http://localhost:8000/login/facebook" flat icon color="indigo">
            <v-icon>fab fa-facebook</v-icon>
          </v-btn>
          <v-btn href="http://localhost:8000/login/google" flat icon color="teal darken-2">
            <img height="24px"
                src="https://upload.wikimedia.org/wikipedia/commons/thumb/5/53/Google_%22G%22_Logo.svg/512px-Google_%22G%22_Logo.svg.png"/>
          </v-btn>
        </v-flex> -->
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<style scoped>
  .login {
    border-radius:20px;
  }
  .gradient {
    background: linear-gradient(40deg, #4a97ce, #5fbf8d);
  }
</style>

<script>
  /* eslint-disable eqeqeq */
  import notification from '../../mixin/notification.js'
  import Card from '../shared/Card'

  export default {
    mixins: [notification],
    components: {Card},
    data () {
      return {
        token: this.$route.query.token,
        provider: this.$route.query.provider,
        loading: false,
        showPassword: false,
        user: {
          email: '',
          password: ''
        },
        rememberMe: false,
        alert: {
          visible: false,
          message: '',
          type: ''
        },
        nextRoute: '/tasks'
      }
    },
    beforeRouteEnter (to, from, next) {
      next((vm) => {
        // se a rota anterior é da tela de gerenciamento ou da gerenciamento compartilhada, incluir valor no nextRoute para depois do login redirecionar pra rota que estava antes
        if (from.name === 'Task' || from.name === 'TaskShared' || from.name === 'Upgrade') {
          vm.nextRoute = from.path
        }
      })
    },
    created () {
      if (!navigator.onLine) {
        this.$router.push('/offline')
      }
    },
    mounted () {
      // Verifica se o link é algum personalizado para ja logar no usuário e deslogar outro
      if (this.$route.query['email']) this.user['email'] = this.$route.query['email']
      if (this.$route.query['senha']) this.user['password'] = this.$route.query['senha']
      if (this.$route.query['email'] && this.$route.query['senha']) {
        this.login()
      } else {
        // Se o usuário estiver logado vai pra tela de tarefas
        if (this.$auth.check() && this.$auth.user().company_id != 25) {
          this.$router.push('/tasks')
        }

        // Caso o usuário tenha marcado para lembrar dos dados, já prepreencher
        if (this.$auth.remember()) {
          let remenberUser = JSON.parse(this.$auth.remember())
          this.user.email = remenberUser.email
          this.user.password = window.atob(remenberUser.password)
          this.rememberMe = true
        }
        if (this.token) {
          this.$auth.oauth2({
            code: true,
            provider: this.provider,
            params: {
              token: this.token
            },
            redirect: {path: this.nextRoute}
          }).then((res) => {
            console.log('success ' + res)
          }, (err) => {
            console.log('error ' + err)
          })
        }
      }
    },
    methods: {
      login () {
        // O auth_token_default em alguns momentos estava permanecesndo no sesionStorage e não trocava de usuário quando logava em outro, portanto esta removendo ele e também alguns outros dados que podem atrapalhar
        localStorage.removeItem('auth_token_default')
        localStorage.removeItem('last_user')
        sessionStorage.removeItem('auth_token_default')
        sessionStorage.removeItem('last_user')
        // Caso o remenber não esteja marcado então verifica se tem remember se tiver desremeber ele
        if (!this.rememberMe && this.$auth.remember()) {
          this.$auth.unremember()
        }
        this.loading = true
        let remenberUser = this.rememberMe ? JSON.stringify({email: this.user.email, password: window.btoa(this.user.password)}) : null
        this.$auth.login({
          body: this.user,
          redirect: this.nextRoute,
          remember: remenberUser,
          staySignedIn: true,
          fetchUser: true
        }).then(res => {
          this.enableSubscription()
        }, err => {
          this.loading = false
          this.$store.commit('snackbar/change_values', {
            text: 'Porfavor, corrija as validações para continuar',
            color: 'warning',
            dialog: true,
            timeout: 6000
          })
          if (err.body.message === 'unauthorized') {
            this.errors.add({
              field: 'password',
              msg: 'A senha ou email estão incorretos'
            })
          }
          this.alert.message = err.body.message === 'unauthorized' ? 'As credenciais estão erradas' : 'Erro no servidor, tente novamente mais tarde'
          this.alert.visible = true
          this.alert.type = 'error'
        })
      },
      toRegister () {
        // estrutura utm criada para rastrear de qual campanha e qual termo o usuário usou
        let routerTracking = document.URL.split('?')[1]
        this.$router.push(`/register?${routerTracking}`)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/auth/Login.vue